import fetch from 'lib/fetch'
import { useMutation } from '@tanstack/react-query'
import { FLASH_MESSAGE, UPDATE_CART_SUMMARY } from 'shared/constants'

const API_PATH = '/store/api/cart_items'

interface CartItem {
  id?: string
  price?: number
  productId: number
  quantity: number
}

const fetchCreate = async ({ price, productId, quantity }: CartItem) =>
  await fetch(API_PATH, {
    method: 'POST',
    body: JSON.stringify({ price, productId, quantity }),
  })

const useCreateMutation = () => {
  const mutation = useMutation({
    mutationFn: ({ productId, quantity, price }: CartItem) =>
      fetchCreate({ price, productId, quantity }),
    onSuccess: () => {
      PubSub.publish(UPDATE_CART_SUMMARY, {
        animateBadge: true,
        showCartDropdown: true,
      })
    },
    onError: (resp: any) => {
      PubSub.publish(FLASH_MESSAGE, {
        message:
          resp?.error?.message ||
          'An error occurred while adding the item to the cart.',
        variant: 'danger',
      })
    },
  })
  return mutation
}

export const CartItemsAPI = {
  useCreateMutation,
}
